import { Link, RadioField, RadioInput } from '@flos/react-ui';
import { useState } from 'react';
import ViewInformationModal from '../../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { COVERABLE_CODE } from '../../../../../constants/coverable';
import type { PrhBuildingOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/house';

const HouseYesNoFormOnsa = ({
    propertyToUpdate,
    formLabel,
    informationModalDescription
}: {
    propertyToUpdate: keyof PrhBuildingOnsaDTO;
    formLabel: string;
    informationModalDescription: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const houseCoverables =
        currentProduct.flavourCode === COVERABLE_CODE.prhHouse
            ? coverables.houses ?? []
            : coverables.holidayHomes ?? [];
    const coverableIndex = houseCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentHouseCoverable = houseCoverables[coverableIndex];
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        updateCoverableInformation({
            [propertyToUpdate]: event.target.value
        });
    };

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <h4>{formLabel}</h4>
            <RadioField
                value={currentHouseCoverable[propertyToUpdate] as string}
                onChange={handleChoiceChange}
            >
                <RadioInput label={'Ja'} value="Yes" />
                <RadioInput label={'Nej'} value="No" />
                <RadioInput label={'Ved ikke'} value="None" />
            </RadioField>
            <Link
                onClick={() => {
                    setShowModal(true);
                }}
                theme="logo"
            >
                {getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK')}
            </Link>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={{
                        title: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK'),
                        description: informationModalDescription
                    }}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </div>
    );
};
export default HouseYesNoFormOnsa;
